// extracted by mini-css-extract-plugin
export default {"customLoader":"loading_customLoader__eDv4R","s3":"loading_s3__T4s3k","center":"loading_center__59pJY"};